import { useEffect } from 'react';

/** Seite registriert eine „sanfte“ Aktualisierung für Pull-to-Refresh (statt Neuladen der ganzen App). fn sollte stabil sein (useCallback). */
export function usePortalRefresh(fn) {
  useEffect(() => {
    if (!fn) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.detail?.wait?.(Promise.resolve(fn()));
    };
    window.addEventListener('portal:refresh', handler);
    return () => window.removeEventListener('portal:refresh', handler);
  }, [fn]);
}

/** Pull-to-Refresh auslösen: Seiten mit usePortalRefresh aktualisieren sich selbst, sonst wird die App neu geladen. */
export async function triggerPortalRefresh() {
  const waits = [];
  const ev = new CustomEvent('portal:refresh', { cancelable: true, detail: { wait: (p) => waits.push(p) } });
  window.dispatchEvent(ev);
  if (!ev.defaultPrevented) {
    window.location.reload();
    return new Promise(() => {});
  }
  await Promise.allSettled(waits);
}

export const splashHide = () => window.__skkSplashHide?.();
